import { useMutation } from 'react-query'

import { updateApprovedQuote as updateApprovedQuoteApi } from '../query-api'

interface UseUpdateApprovedQuoteMutationProps {
  onError?: () => void
  onSuccess?: () => void
}

export const useUpdateApprovedQuoteMutation = ({ onError, onSuccess }: UseUpdateApprovedQuoteMutationProps = {}) => {
  const {
    isLoading,
    mutate: updateApprovedQuote,
    ...rest
  } = useMutation(updateApprovedQuoteApi, { onError, onSuccess })

  return { isProcessing: isLoading, updateApprovedQuote, ...rest }
}
